var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.currentHeader !== _vm.sortBy)?_c('v-icon',{staticClass:"align-middle",attrs:{"width":_vm.width,"height":_vm.height,"name":"unfold_more"}}):_c('v-icon',{staticClass:"align-middle",attrs:{"width":_vm.width,"height":_vm.height,"name":_vm.sortDesc ? 'unfold_up' : 'unfold_down'}})
}
var staticRenderFns = []

export { render, staticRenderFns }